.discord-message .discord-reactions,
.discord-system-message .discord-reactions {
	display: flex;
	-webkit-box-flex: 1;
	-ms-flex: 1 0 auto;
	flex: 1 0 auto;
	align-items: center;
	flex-wrap: wrap;
}
